<template>
	<div class="lg:flex mainlogo">
        <span class="text-lg font-bold ">
            <img src="@/assets/crystaSureLogo.svg" alt=""  v-if="isSidebarToggle" class="crystaSureLogo"/>
            <img src="@/assets/crystaSureShield.svg" alt="" v-else  class="crystaSureShield"/>

        </span>
    </div>
	<div class="fixed sidebar bg-white sidenav flex flex-col justify-between h-full sideheight" :class="{ 'w-40': isSidebarToggle, 'w-10': !isSidebarToggle }">
		<ul>
			<!-- <li 
				@click="navigate('dashboard', 'dashboard')" 
				class="cursor-pointer text-black hover:bg-primary svg-icon pl-2.5 pr-2.5 adjustWidthWhenHover" 
				@mouseover="displayToolTipMethod('Dashboard', 'Dashboard')"
				@mouseout="hideToolTip()" 
				:class="selectedOptionName === 'dashboard' ? 'bg-primary text-white font-bold a svg-icon123 adjustWidthWhenHover' : 'text-black font-normal adjustWidthWhenHover'" >
				<div>
					<a class="flex  controlalign navchild items-center hover:text-white">
						<div class="py-0.5">
						<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_2328_26181)">
                                <path
                                    d="M5.02793 2.80666L1.13449 4.48927L1.12968 5.06084L1.12646 5.63402H1.67074H2.21342L2.22305 5.70627C2.24553 5.87003 2.37879 6.04985 2.53613 6.12692L2.62765 6.17188H8.96954H15.3114L15.3869 6.13655C15.5539 6.05949 15.6968 5.87646 15.716 5.71269L15.7257 5.63402H16.2539H16.7805L16.7773 5.06245L16.7725 4.49087L12.8646 2.80666C10.7164 1.88026 8.94867 1.12245 8.93903 1.12405C8.9294 1.12405 7.16972 1.88187 5.02793 2.80666Z"
                                    fill="black"
                                />
                                <path
                                    d="M3.19769 10.1138V13.4822L2.89746 13.4902C2.61006 13.4967 2.5908 13.4999 2.49768 13.5416C2.37887 13.5946 2.25042 13.7198 2.19905 13.8322C2.16533 13.9061 2.16212 13.9382 2.1573 14.2689L2.15088 14.627H8.95998H15.7691V14.2818C15.7691 13.9767 15.7659 13.9285 15.737 13.8515C15.6904 13.7262 15.57 13.5994 15.4448 13.5432C15.3484 13.4999 15.3308 13.4967 15.0434 13.4902L14.7415 13.4822V10.1138V6.74374H13.6899H12.6383V10.1154V13.487H12.1245H11.6107V10.1154V6.74374H10.5591H9.50747V10.1154V13.487H8.9937H8.47992V10.1154V6.74374H7.42829H6.37667V10.1154V13.487H5.86289H5.34912V10.1154V6.74374H4.27341H3.19769V10.1138Z"
                                    fill="black"
                                />
                                <path
                                    d="M1.51675 15.2197C1.36262 15.2727 1.24542 15.3754 1.17156 15.5263C1.13463 15.597 1.13463 15.6114 1.12982 16.236L1.125 16.875H8.95362H16.7838L16.7774 16.252L16.7726 15.6307L16.7277 15.5328C16.6731 15.414 16.5462 15.2855 16.4354 15.2341L16.3552 15.1972L8.97771 15.194C1.91172 15.1908 1.59703 15.1908 1.51675 15.2197Z"
                                    fill="black"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_2328_26181">
                                    <rect width="18" height="18" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
						</div>
						<div class="item-name leading-5 text-sm pl-2" :class="selectedOptionName === 'dashboard' ? 'text-white font-bold' : 'text-listIconColor font-normal'" v-if="isSidebarToggle">Dashboard</div>
					</a>
				</div> 	
				<div v-if="displayToolTip == true && tipText == 'Dashboard' && iconName == 'Dashboard'" class="absolute z-50  rounded tooltipwidth transform-y-top left-11 whitespace-nowrap">
					<div class="px-2 text-white bg-tooltip">Dashboard</div>
				</div>
			</li> -->
			<li 
				 @click="navigate('audit', 'audit')" 
				class="cursor-pointer text-black hover:bg-primary svg-icon pl-2.5 pr-2.5 adjustWidthWhenHover"
				@mouseover="displayToolTipMethod('Audit', 'Audit')"
				@mouseout="hideToolTip()"
				:class="selectedOptionName === 'audit' ? 'bg-primary text-white font-normal a svg-icon123 adjustWidthWhenHover' : 'text-black font-normal adjustWidthWhenHover'" 
			>
				<div>
					<a class="flex  controlalign navchild items-center hover:text-white py-1.5">
						<div class="py-0.5">
						<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_2328_26181)">
                                <path
                                    d="M5.02793 2.80666L1.13449 4.48927L1.12968 5.06084L1.12646 5.63402H1.67074H2.21342L2.22305 5.70627C2.24553 5.87003 2.37879 6.04985 2.53613 6.12692L2.62765 6.17188H8.96954H15.3114L15.3869 6.13655C15.5539 6.05949 15.6968 5.87646 15.716 5.71269L15.7257 5.63402H16.2539H16.7805L16.7773 5.06245L16.7725 4.49087L12.8646 2.80666C10.7164 1.88026 8.94867 1.12245 8.93903 1.12405C8.9294 1.12405 7.16972 1.88187 5.02793 2.80666Z"
                                    fill="black"
                                />
                                <path
                                    d="M3.19769 10.1138V13.4822L2.89746 13.4902C2.61006 13.4967 2.5908 13.4999 2.49768 13.5416C2.37887 13.5946 2.25042 13.7198 2.19905 13.8322C2.16533 13.9061 2.16212 13.9382 2.1573 14.2689L2.15088 14.627H8.95998H15.7691V14.2818C15.7691 13.9767 15.7659 13.9285 15.737 13.8515C15.6904 13.7262 15.57 13.5994 15.4448 13.5432C15.3484 13.4999 15.3308 13.4967 15.0434 13.4902L14.7415 13.4822V10.1138V6.74374H13.6899H12.6383V10.1154V13.487H12.1245H11.6107V10.1154V6.74374H10.5591H9.50747V10.1154V13.487H8.9937H8.47992V10.1154V6.74374H7.42829H6.37667V10.1154V13.487H5.86289H5.34912V10.1154V6.74374H4.27341H3.19769V10.1138Z"
                                    fill="black"
                                />
                                <path
                                    d="M1.51675 15.2197C1.36262 15.2727 1.24542 15.3754 1.17156 15.5263C1.13463 15.597 1.13463 15.6114 1.12982 16.236L1.125 16.875H8.95362H16.7838L16.7774 16.252L16.7726 15.6307L16.7277 15.5328C16.6731 15.414 16.5462 15.2855 16.4354 15.2341L16.3552 15.1972L8.97771 15.194C1.91172 15.1908 1.59703 15.1908 1.51675 15.2197Z"
                                    fill="black"
                                />
                            </g>
                            <defs>
                                <clipPath id="clip0_2328_26181">
                                    <rect width="18" height="18" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>
						</div>
						<div class="item-name leading-5 text-sm pl-2.5" :class="selectedOptionName === 'audit' ? 'text-white font-bold' : 'text-listIconColor font-normal'" v-if="isSidebarToggle">Audit</div>
					</a>
				</div>
				<div v-if="displayToolTip == true && tipText == 'Audit' && iconName == 'Audit'" class="absolute z-50  rounded tooltipwidth transform-y-top left-11 whitespace-nowrap">
					<div class="px-2 text-white bg-tooltip">Audit</div>
				</div>
			</li>
			<li 
				@click="navigate('myTasks', 'myTasks')" 
				class="cursor-pointer text-black hover:bg-primary svg-icon pl-2.5 pr-2.5 adjustWidthWhenHover mt-1" 
				@mouseover="displayToolTipMethod('MyTasks', 'MyTasks')"
				@mouseout="hideToolTip()" 
				:class="selectedOptionName === 'myTasks' ? 'bg-primary text-white font-bold a svg-icon123 adjustWidthWhenHover' : 'text-black font-normal adjustWidthWhenHover'" >
				<div>
					<a class="flex navchild  controlalign items-center hover:text-white py-1.5">
						<div class="py-0.5">
						<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M5.29463 2.10857C5.26034 2.07416 5.21959 2.04685 5.17472 2.02822C5.12985 2.00959 5.08174 2 5.03316 2C4.98457 2 4.93647 2.00959 4.8916 2.02822C4.84673 2.04685 4.80598 2.07416 4.77168 2.10857L2.81277 4.0561L2.11448 3.37565C2.08019 3.34124 2.03944 3.31393 1.99457 3.2953C1.9497 3.27667 1.90159 3.26708 1.85301 3.26708C1.80442 3.26708 1.75632 3.27667 1.71145 3.2953C1.66658 3.31393 1.62583 3.34124 1.59153 3.37565L1.10857 3.85922C1.07416 3.89352 1.04685 3.93427 1.02822 3.97914C1.00959 4.02401 1 4.07211 1 4.1207C1 4.16928 1.00959 4.21739 1.02822 4.26226C1.04685 4.30713 1.07416 4.34788 1.10857 4.38217L2.57252 5.84028C2.6456 5.90974 2.74256 5.94847 2.84338 5.94847C2.9442 5.94847 3.04117 5.90974 3.11424 5.84028L3.59381 5.35978L5.81481 3.13909C5.88401 3.06984 5.92311 2.97609 5.92363 2.87819C5.92415 2.78028 5.88604 2.68613 5.81758 2.61614L5.29463 2.10857ZM5.29463 7.00554C5.26034 6.97112 5.21959 6.94382 5.17472 6.92519C5.12985 6.90655 5.08174 6.89696 5.03316 6.89696C4.98457 6.89696 4.93647 6.90655 4.8916 6.92519C4.84673 6.94382 4.80598 6.97112 4.77168 7.00554L2.81277 8.96568L2.11448 8.28584C2.08019 8.25143 2.03944 8.22412 1.99457 8.20549C1.9497 8.18686 1.90159 8.17727 1.85301 8.17727C1.80442 8.17727 1.75632 8.18686 1.71145 8.20549C1.66658 8.22412 1.62583 8.25143 1.59153 8.28584L1.10857 8.76849C1.07416 8.80279 1.04685 8.84354 1.02822 8.88841C1.00959 8.93328 1 8.98138 1 9.02997C1 9.07855 1.00959 9.12666 1.02822 9.17153C1.04685 9.2164 1.07416 9.25715 1.10857 9.29144L2.56883 10.7526C2.64185 10.8221 2.73877 10.8608 2.83954 10.8608C2.9403 10.8608 3.03722 10.8221 3.11024 10.7526L3.5932 10.27L5.8142 8.04836C5.88313 7.97959 5.9221 7.88636 5.92262 7.78899C5.92314 7.69162 5.88517 7.59799 5.81697 7.52849L5.29463 7.00554ZM2.96874 12.3369C2.15386 12.3369 1.47402 12.9982 1.47402 13.8134C1.47402 14.6286 2.15447 15.29 2.96874 15.29C3.36034 15.29 3.73591 15.1344 4.01282 14.8575C4.28973 14.5806 4.4453 14.205 4.4453 13.8134C4.4453 13.4218 4.28973 13.0462 4.01282 12.7693C3.73591 12.4924 3.36034 12.3369 2.96874 12.3369ZM16.2578 12.829H7.39843C7.26789 12.829 7.1427 12.8809 7.0504 12.9732C6.9581 13.0655 6.90624 13.1907 6.90624 13.3212V14.3056C6.90624 14.4361 6.9581 14.5613 7.0504 14.6536C7.1427 14.7459 7.26789 14.7978 7.39843 14.7978H16.2578C16.3883 14.7978 16.5135 14.7459 16.6058 14.6536C16.6981 14.5613 16.75 14.4361 16.75 14.3056V13.3212C16.75 13.1907 16.6981 13.0655 16.6058 12.9732C16.5135 12.8809 16.3883 12.829 16.2578 12.829ZM16.2578 2.98528H7.39843C7.26789 2.98528 7.1427 3.03714 7.0504 3.12944C6.9581 3.22174 6.90624 3.34693 6.90624 3.47747V4.46185C6.90624 4.59238 6.9581 4.71757 7.0504 4.80988C7.1427 4.90218 7.26789 4.95403 7.39843 4.95403H16.2578C16.3883 4.95403 16.5135 4.90218 16.6058 4.80988C16.6981 4.71757 16.75 4.59238 16.75 4.46185V3.47747C16.75 3.34693 16.6981 3.22174 16.6058 3.12944C16.5135 3.03714 16.3883 2.98528 16.2578 2.98528ZM16.2578 7.90716H7.39843C7.26789 7.90716 7.1427 7.95902 7.0504 8.05132C6.9581 8.14362 6.90624 8.26882 6.90624 8.39935V9.38373C6.90624 9.51426 6.9581 9.63945 7.0504 9.73176C7.1427 9.82406 7.26789 9.87592 7.39843 9.87592H16.2578C16.3883 9.87592 16.5135 9.82406 16.6058 9.73176C16.6981 9.63945 16.75 9.51426 16.75 9.38373V8.39935C16.75 8.26882 16.6981 8.14362 16.6058 8.05132C16.5135 7.95902 16.3883 7.90716 16.2578 7.90716Z"
                                fill="black"
                            />
                        </svg>
						</div>
						<div class="item-name leading-5 text-sm pl-2.5" :class="selectedOptionName === 'myTasks' ? 'text-white font-bold' : 'text-listIconColor font-normal'" v-if="isSidebarToggle">My Tasks</div>
					</a>
				</div>
				<div v-if="displayToolTip == true && tipText == 'MyTasks' && iconName == 'MyTasks'" class="absolute z-50  rounded tooltipwidth transform-y-top left-11 whitespace-nowrap">
					<div class="px-2 text-white bg-tooltip">My Tasks</div>
				</div>
			</li>
			<li @click="navigate('myFindings', 'myFindings')"
			 class="cursor-pointer text-black hover:bg-primary svg-icon pl-2.5 pr-2.5 adjustWidthWhenHover mt-1"  
			 @mouseover="displayToolTipMethod('MyFindings', 'MyFindings')"
			 @mouseout="hideToolTip()"
			 :class="selectedOptionName === 'myFindings' ? 'bg-primary text-white font-normal a svg-icon123 adjustWidthWhenHover' : 'text-black font-normal adjustWidthWhenHover'">
				<div>
					<a class="flex navchild controlalign items-center hover:text-white py-1.5">
						<div class="py-0.5">
						<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
							<g id="Audit">
								<g id="Group">
									<path id="Vector" d="M12.3359 1.14453V4.44563H15.637L12.3359 1.14453Z" fill="black" />
									<path
										id="Vector_2"
										d="M12.0898 4.9375C11.9538 4.9375 11.8438 4.8275 11.8438 4.69141V1H2.98438C2.44026 1 2 1.44026 2 1.98438V15.7656C2 16.3097 2.44026 16.75 2.98438 16.75H14.7969C15.341 16.75 15.7812 16.3097 15.7812 15.7656V4.9375H12.0898ZM4.70703 5.42969H8.64453C8.78062 5.42969 8.89062 5.53969 8.89062 5.67578C8.89062 5.81187 8.78062 5.92188 8.64453 5.92188H4.70703C4.57094 5.92188 4.46094 5.81187 4.46094 5.67578C4.46094 5.53969 4.57094 5.42969 4.70703 5.42969ZM13.0742 13.5508H4.70703C4.57094 13.5508 4.46094 13.4408 4.46094 13.3047C4.46094 13.1686 4.57094 13.0586 4.70703 13.0586H13.0742C13.2103 13.0586 13.3203 13.1686 13.3203 13.3047C13.3203 13.4408 13.2103 13.5508 13.0742 13.5508ZM13.0742 12.0742H4.70703C4.57094 12.0742 4.46094 11.9642 4.46094 11.8281C4.46094 11.692 4.57094 11.582 4.70703 11.582H13.0742C13.2103 11.582 13.3203 11.692 13.3203 11.8281C13.3203 11.9642 13.2103 12.0742 13.0742 12.0742ZM13.0742 10.5977H4.70703C4.57094 10.5977 4.46094 10.4877 4.46094 10.3516C4.46094 10.2155 4.57094 10.1055 4.70703 10.1055H13.0742C13.2103 10.1055 13.3203 10.2155 13.3203 10.3516C13.3203 10.4877 13.2103 10.5977 13.0742 10.5977ZM13.0742 9.12109H4.70703C4.57094 9.12109 4.46094 9.01109 4.46094 8.875C4.46094 8.73891 4.57094 8.62891 4.70703 8.62891H13.0742C13.2103 8.62891 13.3203 8.73891 13.3203 8.875C13.3203 9.01109 13.2103 9.12109 13.0742 9.12109ZM13.0742 7.64453H4.70703C4.57094 7.64453 4.46094 7.53453 4.46094 7.39844C4.46094 7.26235 4.57094 7.15234 4.70703 7.15234H13.0742C13.2103 7.15234 13.3203 7.26235 13.3203 7.39844C13.3203 7.53453 13.2103 7.64453 13.0742 7.64453Z"
										fill="black"
									/>
								</g>
							</g>
						</svg>
						</div>
						<div class="item-name leading-5 text-sm pl-2.5" :class="selectedOptionName === 'myFindings' ? 'text-white font-bold' : 'text-listIconColor font-normal'" v-if="isSidebarToggle">My Findings</div>
					</a>
				</div>
				<div v-if="displayToolTip == true && tipText == 'MyFindings' && iconName == 'MyFindings'"  class="absolute z-50  rounded tooltipwidth transform-y-top left-11 whitespace-nowrap">
					<div class="px-2 text-white bg-tooltip">My Findings</div>
				</div>
			</li>
			<li 
				@click="navigate('findingTask', 'findingTask')" 
				class="cursor-pointer text-black hover:bg-primary svg-icon pl-2.5 pr-2.5 adjustWidthWhenHover mt-1" 
				@mouseover="displayToolTipMethod('My Finding Tasks', 'My Finding Tasks')"
				@mouseout="hideToolTip()" 
				:class="selectedOptionName === 'findingTask' ? 'bg-primary text-white font-bold a svg-icon123 adjustWidthWhenHover' : 'text-black font-normal adjustWidthWhenHover'" >
				<div>
					<a class="flex navchild  controlalign items-center hover:text-white py-1.5">
						<div class="py-0.5">
							<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
							<g id="Audit">
								<g id="Group">
									<path id="Vector" d="M12.3359 1.14453V4.44563H15.637L12.3359 1.14453Z" fill="black" />
									<path
										id="Vector_2"
										d="M12.0898 4.9375C11.9538 4.9375 11.8438 4.8275 11.8438 4.69141V1H2.98438C2.44026 1 2 1.44026 2 1.98438V15.7656C2 16.3097 2.44026 16.75 2.98438 16.75H14.7969C15.341 16.75 15.7812 16.3097 15.7812 15.7656V4.9375H12.0898ZM4.70703 5.42969H8.64453C8.78062 5.42969 8.89062 5.53969 8.89062 5.67578C8.89062 5.81187 8.78062 5.92188 8.64453 5.92188H4.70703C4.57094 5.92188 4.46094 5.81187 4.46094 5.67578C4.46094 5.53969 4.57094 5.42969 4.70703 5.42969ZM13.0742 13.5508H4.70703C4.57094 13.5508 4.46094 13.4408 4.46094 13.3047C4.46094 13.1686 4.57094 13.0586 4.70703 13.0586H13.0742C13.2103 13.0586 13.3203 13.1686 13.3203 13.3047C13.3203 13.4408 13.2103 13.5508 13.0742 13.5508ZM13.0742 12.0742H4.70703C4.57094 12.0742 4.46094 11.9642 4.46094 11.8281C4.46094 11.692 4.57094 11.582 4.70703 11.582H13.0742C13.2103 11.582 13.3203 11.692 13.3203 11.8281C13.3203 11.9642 13.2103 12.0742 13.0742 12.0742ZM13.0742 10.5977H4.70703C4.57094 10.5977 4.46094 10.4877 4.46094 10.3516C4.46094 10.2155 4.57094 10.1055 4.70703 10.1055H13.0742C13.2103 10.1055 13.3203 10.2155 13.3203 10.3516C13.3203 10.4877 13.2103 10.5977 13.0742 10.5977ZM13.0742 9.12109H4.70703C4.57094 9.12109 4.46094 9.01109 4.46094 8.875C4.46094 8.73891 4.57094 8.62891 4.70703 8.62891H13.0742C13.2103 8.62891 13.3203 8.73891 13.3203 8.875C13.3203 9.01109 13.2103 9.12109 13.0742 9.12109ZM13.0742 7.64453H4.70703C4.57094 7.64453 4.46094 7.53453 4.46094 7.39844C4.46094 7.26235 4.57094 7.15234 4.70703 7.15234H13.0742C13.2103 7.15234 13.3203 7.26235 13.3203 7.39844C13.3203 7.53453 13.2103 7.64453 13.0742 7.64453Z"
										fill="black"
									/>
								</g>
							</g>
						</svg>
						</div>
						<div class="item-name leading-5 text-sm pl-2.5" :class="selectedOptionName === 'findingTask' ? 'text-white font-bold' : 'text-listIconColor font-normal'" v-if="isSidebarToggle">CAPA Tasks</div>
					</a>
				</div>
				<div v-if="displayToolTip == true && tipText == 'My Finding Tasks' && iconName == 'My Finding Tasks'" class="absolute z-50  rounded tooltipwidth transform-y-top left-11 whitespace-nowrap">
					<div class="px-2 text-white bg-tooltip">CAPA Tasks</div>
				</div>
			</li>
		</ul>
		<ul class="bottomUl">
			<li class="relative">
				<hr class="mb-4" />
				<img src="@/assets/leftarrow.svg" class=" icon   arrowIcon leftarrow absolute cursor-pointer" alt="" @click="toggleSideMenuBar()" v-if="isSidebarToggle" />
				<img src="@/assets/rightarrow.svg" class="arrowiconRight  icon  rightarrow absolute cursor-pointer" alt="" @click="toggleSideMenuBar()" v-else />
			</li>
			<li v-if="canShowOrgSettings" class="setting">
				<a @click="triggerNavToSettings()" class="flex navchild py-1 pl-2.5" >
					<img src="@/assets/settings.svg" class="h-5 icon" :class="{ 'pr-1.5': isSidebarToggle, '': !isSidebarToggle }" />
					<div class="item-name leading-5 text-sm text-black" v-if="isSidebarToggle">Settings</div>
				</a>
			</li>
		</ul>
		
	</div>
	<div class="fixed z-50 bg-white w-40 px-2 py-1 min-h-30 flex flex-col justify-center" v-if="appsVisible">
		<!-- <div class="flex flex-row items-center cursor-pointer">
			<div class="flex flex-col mr-1 w-2/4 items-center" @click="triggerNav('monitor')">
				<img src="@/assets/training.svg" alt="" class="icn h-6 w-6 ml-2" />
				<div class="nav-item-label-container">
					<div class="nav-item-label">Monitor</div>
				</div>
			</div>
			<div class="flex flex-row items-center cursor-pointer">
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
				<g clip-path="url(#clip0_4516_14738)">
				<path d="M0 0C7.92 0 15.84 0 24 0C24 7.92 24 15.84 24 24C16.08 24 8.16 24 0 24C0 16.08 0 8.16 0 0Z" fill="#FF9A00"/>
				<path d="M19.6399 17.0902V8.18107C19.6399 7.67475 19.4388 7.18916 19.0808 6.83114C18.7227 6.47311 18.2371 6.27198 17.7308 6.27198H17.0945C17.0944 5.97653 17.0258 5.68513 16.894 5.42071C16.7622 5.15629 16.5708 4.92607 16.3349 4.74817C16.099 4.57027 15.8251 4.44954 15.5346 4.3955C15.2441 4.34145 14.9451 4.35556 14.661 4.43671L12.7519 4.98271C12.4741 5.06217 12.2181 5.20408 12.0036 5.39762C11.789 5.20408 11.533 5.06217 11.2552 4.98271L9.3461 4.43671C9.06201 4.35556 8.76297 4.34145 8.4725 4.3955C8.18204 4.44954 7.90809 4.57027 7.6722 4.74817C7.43632 4.92607 7.24494 5.15629 7.11314 5.42071C6.98134 5.68513 6.9127 5.97653 6.91264 6.27198H6.27628C5.76996 6.27198 5.28437 6.47311 4.92635 6.83114C4.56832 7.18916 4.36719 7.67475 4.36719 8.18107V17.0902H11.3672V18.3629H8.82173V19.6356H15.1854V18.3629H12.6399V17.0902H19.6399ZM12.6399 6.81798C12.64 6.67977 12.685 6.54534 12.7683 6.43501C12.8515 6.32467 12.9684 6.24444 13.1013 6.20643L15.0104 5.66107C15.0673 5.6446 15.1261 5.63604 15.1854 5.63562C15.3541 5.63562 15.516 5.70266 15.6353 5.822C15.7547 5.94134 15.8217 6.1032 15.8217 6.27198V10.2467L12.6399 11.1554V6.81798ZM8.18537 6.27198C8.18551 6.17354 8.20849 6.07648 8.25249 5.98843C8.29649 5.90038 8.36032 5.82373 8.43896 5.76453C8.51759 5.70532 8.6089 5.66516 8.70568 5.64721C8.80246 5.62925 8.90209 5.634 8.99673 5.66107L10.9058 6.20643C11.0387 6.24444 11.1556 6.32467 11.2388 6.43501C11.3221 6.54534 11.3671 6.67977 11.3672 6.81798V11.1554L8.18537 10.2467V6.27198ZM5.63991 8.18107C5.63991 8.0123 5.70696 7.85043 5.8263 7.73109C5.94564 7.61175 6.1075 7.54471 6.27628 7.54471H6.91264V11.2063L12.0036 12.6611L17.0945 11.2063V7.54471H17.7308C17.8996 7.54471 18.0615 7.61175 18.1808 7.73109C18.3001 7.85043 18.3672 8.0123 18.3672 8.18107V15.8174H5.63991V8.18107Z" fill="white"/>
				</g>
				<defs>
				<clipPath id="clip0_4516_14738">
				<rect width="24" height="24" rx="4" fill="white"/>
				</clipPath>
				</defs>
				</svg>

				<div class="nav-item-label-container ml-2">
					<div class="text-sm font-semibold">Training</div>
					<div class="active-border"></div>
				</div>
			</div>
			<div class="flex flex-col w-2/4 items-center cursor-pointer" @click="triggerNav('workflow')">
				<img src="@/assets/training2.svg" alt="" class="icn h-8 w-8 ml-2" />
				<div class="nav-item-label-container">
					<div class="text-xs">Training</div>
					<div class="active-border"></div>
				</div>
			</div>
		</div> -->
	</div>
</template>
<style scoped >
.crystaSureShield{
	padding-top:33px ;
	width:20px;
	margin-right: 10px;
}
.adjustWidthWhenHover{
    border-radius: 5px;
    margin-left:3px;
    margin-right:3px;
}
.crystaSureLogo
{
	padding-top:20px ;
	margin-right: 13px;
	width:150px;
}
.sideheight{
	height: 100%;
    z-index: 51;
	padding-top:85px;
	border-right:1px solid rgb(233, 233, 233);
}
.mainlogo{
	position:fixed;
	margin-left:9px;
	z-index:52;
}
.setting{
    height: 35px;
    margin-top: 5px;
}
.bottomUl{
    height: 51px;
}
.sideToolTip {
    background: #1976d2;
    color: white;
    left: 110%;
    padding: 5px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 28px !important;
    font-size: 14px;
    font-weight: 400;
}
.bg-tooltip{
	background-color: #1976d2;
	border-radius:3px;
}
.min-h-30 {
	height: 50px;
}
.w-40 {
	width: 170px;
}
.w-3 {
	width: 15px;
}
.transform-y-top{
	transform: translateY(-26px);
}
.shadow {
	--tw-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.25);
	box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.leftarrow,
.rightarrow {
	/* height: 1.25rem;
	width: 1.25rem; */
	margin-top: -27px;
}
.controlalign{
	padding-top:6px;
	padding-bottom: 6px;
}
.a:hover {
	color: white;
	font-weight: bold;
}
.svg-icon123 div a svg path,
.svg-icon123 div a svg rect,
.svg-icon:hover path,
.svg-Image:hover svg path,
.svg-Image:hover svg rect,
.svg-icon:hover rect
 {
    fill: white;
}
.svg-icon:hover {
	color: white;
}
.icon:hover {
	transition: none !important;
}
.tooltipwidth {
	width: auto;
	z-index: 200 !important;
}
.arrowIcon{
	height:22px;
	width:22px;
	margin-left:156px;
}
.arrowiconRight{
	height:22px;
	width:22px;
	margin-left:29px;
}
</style>
<script lang="ts">
import { defineComponent } from 'vue';
import { emitter } from '../main';
import { mapGetters } from 'vuex';
export default defineComponent({
	data(): any {
		return {
			resizeTimeout : 0,
			isSidebarToggle: true,
			appsVisible: false,
			menuVisible: false,
			selectedOptionName: '',
			passingRouteName: '',
			a: 0,
			displayToolTip: false,
            tiptext: '',
            iconName: '',
			menus: [
				{
					optionName: 'audit',
					optionRoute: 'audit',
					// defaultoptionImage: require('@/assets/Informationpage.svg'),
                    // colouredoptionImage: require('@/assets/InformationColored.svg'),
					displayOptionName: 'Audit'
				}
			]
		};
	},

	methods: {
		navigate(name: any, routerOption: any) {
			this.$store.dispatch('selectedToggle', this.isSidebarToggle);
			this.$store.dispatch('selectedRoute', name);
			this.$router.push({ name: routerOption });
		},
		displayToolTipMethod(name: any, tiptext: any) {
            if (this.isSidebarToggle == false) {
                this.displayToolTip = true;
                this.tipText = tiptext;
                this.iconName = name;
            }
        },
		redirectToOrgApp() {
			const session = localStorage.getItem('AUTH_ID');
			const orgUi = process.env.VUE_APP_ORG_UI;
			const authUi = process.env.VUE_APP_AUTH_UI;

			if (session && orgUi) {
				window.location.href = `${orgUi}/?session=${encodeURIComponent(session)}`;
				return;
			}

			if (authUi && orgUi) {
				const returnTo = encodeURIComponent(orgUi);
				const sessionParam = session ? `&session=${encodeURIComponent(session)}` : '';
				window.location.href = `${authUi}/session?returnTo=${returnTo}${sessionParam}`;
			}
		},
		triggerNavToSettings() {
			this.redirectToOrgApp();
		},
        hideToolTip() {
            this.displayToolTip = false;
        },
		toggleSideMenuBar() {
			this.isSidebarToggle = !this.isSidebarToggle;
            this.$store.dispatch('selectedToggle', this.isSidebarToggle);
            emitter.emit('toggle-sidebar', this.isSidebarToggle);
		},
		triggerNav(app: string) {
			if (app == 'workflow') {
				window.location.href = `${process.env.VUE_APP_AUTH_UI}/session?returnTo=${process.env.VUE_APP_WORKFLOW_UI}`;
			} else {
				window.location.href = `${process.env.VUE_APP_AUTH_UI}/session?returnTo=${app == 'monitor' ? process.env.VUE_APP_MONITOR_UI : process.env.VUE_APP_TRAINING_UI}`;
			}
		},
		 debouncedHandleResize() {
            clearTimeout(this.resizeTimeout);
            this.resizeTimeout = setTimeout(this.handleResize, 100); // Adjust debounce time as needed
        },
		handleResize() {
            if(window.innerWidth<1164)
            {
                this.$store.dispatch('selectedToggle', false);
                this.isSidebarToggle = false;
                emitter.emit('toggle-sidebar', this.isSidebarToggle);
                // console.log("hii checking reponsive or not");
            }
            else if(this.isSidebarToggle == false){
                this.$store.dispatch('selectedToggle', true);
                this.isSidebarToggle = true;
                emitter.emit('toggle-sidebar', this.isSidebarToggle);
                // console.log("big screen");
            }
        },
	},
	computed: {
		currentRouteName() {
			return this.$route.name;
		},
		canShowOrgSettings(): boolean {
			const roleId = this.userInfo.roleId ?? this.userInfo.role_id;
			const orgType = this.userInfo.organisationType;

			if (orgType === 10701) {
				return roleId === 10214 || roleId === 10215;
			}
			if (orgType === 10702) {
				return roleId === 10215;
			}
			return false;
		},
		...mapGetters({ userInfo: 'userInfo', toggleState: 'toggle' })
	},
	created(){
		this.handleResize()
	},
	mounted() {
		 window.addEventListener('resize', this.debouncedHandleResize);
		if (this.$route.path.includes('/myTasks') || Object.keys(this.$route.query).includes('myTasks')) {
			this.passingRouteName = 'myTasks';
		} else if (this.$route.path.includes('/myFindings') || this.$route.path.includes('/findingInformation')) {
			this.passingRouteName = 'myFindings';
		}
		else if (this.$route.path.includes('/findingsTask') || this.$route.path.includes('/findingTasks')) {
            this.passingRouteName = 'findingTask';
		}
		// else if (this.$route.path.includes('/dashboard')) {
		// 	this.passingRouteName = 'dashboard';
		// }
		 else if (this.$route.path.includes('/audit')) {
			this.passingRouteName = 'audit';
		}
		// console.log(this.passingRouteName, 'this.passingRouteName');
		this.selectedOptionName = this.passingRouteName;
		// console.log('selectedOptionName', this.selectedOptionName);
		emitter.on('apps-sidemenubar', (isMenuToggle) => {
			this.menuVisible = isMenuToggle;
		});
		emitter.on('apps', (isToggle: any) => {
			this.menuVisible = isToggle;
		});
		this.isSidebarToggle = this.toggleState;
		// emitter.on('toggle-sidebar', (isToggle: any) => {
		// 	this.isSidebarToggle = isToggle;
		// });
	},
	 beforeUnmount() {
        window.removeEventListener('resize', this.debouncedHandleResize);
    },
});
</script>